const COMPACT_SUFFIXES = ["K", "M", "B"] as const;
const COMPACT_DIVISORS = [1_000, 1_000_000, 1_000_000_000] as const;

/** At most one decimal place; omit trailing `.0`. */
function formatCompactMantissa(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  if (Number.isInteger(rounded)) {
    return String(rounded);
  }
  return rounded.toFixed(1);
}

function formatWithSuffix(abs: number, suffixIndex: number): string {
  let idx = suffixIndex;
  let mantissa = abs / COMPACT_DIVISORS[idx];
  mantissa = Math.round(mantissa * 10) / 10;

  // e.g. 999999 → 1000k → 1m; 999999999 → 1000m → 1b
  while (mantissa >= 1000 && idx < COMPACT_SUFFIXES.length - 1) {
    idx += 1;
    mantissa = abs / COMPACT_DIVISORS[idx];
    mantissa = Math.round(mantissa * 10) / 10;
  }

  return `${formatCompactMantissa(mantissa)}${COMPACT_SUFFIXES[idx]}`;
}

/**
 * Formats a number with k / m / b suffixes.
 * - Below 100: whole number (rounded)
 * - 100–999: k suffix (e.g. 0.1k, 0.9k)
 * - 1000+: k / m / b with rollover when rounding would hit 1000 of a unit
 */
export function formatCompactNumber(value: number): string {
  if (Number.isNaN(value)) return "N/A";

  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  const roundedWhole = Math.round(abs);
  if (roundedWhole < 100) {
    return sign + String(roundedWhole);
  }

  if (abs < 1_000) {
    return sign + formatWithSuffix(abs, 0);
  }

  let suffixIndex = 0;
  if (abs >= 1_000_000_000) suffixIndex = 2;
  else if (abs >= 1_000_000) suffixIndex = 1;

  return sign + formatWithSuffix(abs, suffixIndex);
}
